/*
$(function(){
  setTimeout(function(){ 
    $("body").addClass("on-load");
  }, 800);
});
$(function(){
  setTimeout(function(){ 
      $('.product-info__block-item > .payment-terms').wrapAll('<dd class="ac-inner">');
      $(".ac-inner").before('<dt class="ac-tit">ギフトラッピングを選択</dt>');
  $(".ac-inner .gpo-container").before('<p class="bag-link"><a href="/pages/gift-service" target="_blank">ラッピングについての詳細はこちら</a></p>');
      $('.ac-tit, .ac-inner').wrapAll('<dl class="ac">');
  }, 500);

});
*/


$(function(){
  setTimeout(function(){ 
    $("body#blog").addClass("on-load");
  }, 500);
  setTimeout(function(){ 
    $("body#product").addClass("on-load");
  }, 800);
  setTimeout(function(){ 
      $('.shopify-product-form > .gpo-container, .shopify-product-form > .gpo-hidden-inputs').wrapAll('<dd class="ac-inner">');
      $(".ac-inner").before('<dt class="ac-tit">ギフトラッピングを選択</dt>');
  $(".ac-inner .gpo-container").before('<p class="prose bag-link"><a href="/pages/gift-service" target="_blank">ギフトラッピングについて</a></p>');
      $('.ac-tit, .ac-inner').wrapAll('<dl class="ac">');
  }, 500);
});

$(document).on('click','.ac dt',function () {
		$(this).next('dd').slideToggle();
		$(this).toggleClass('open');
});
$(document).on('click','.ac-info dt',function () {
		$(this).next('dd').slideToggle();
		$(this).toggleClass('open');
});

$(function(){
	$(window).scroll(function () {
		if ($(this).scrollTop() > 0 ) {
  $("body").addClass("offwhite");
		} else {
  $("body").removeClass("offwhite");
		}
	});
});


